import { Controller } from "@hotwired/stimulus"

let elements
let paymentElement
let stripe
// Connects to data-controller="stripe"
export default class extends Controller {
  static targets = [ 'cardElement', 'cardErrors', 'form', 'amountInput', 'amountDisplay', 'saveAmountBtn', 'submitBtn', 'editAmountBtn' ]

  connect() {
    console.log("stripe controller")
    //ensure Stripe loaded
    var setStripe = setInterval( ()=>{
      if (typeof Stripe === "function"){

        console.log(this.amountInputTarget.value )
        this.amountInputTarget.value = (this.amountInputTarget.value ||= 1) //set to one if page is loaded without value (required for stripe element amount)
        paymentElement = this.checkoutElement()
    
        clearInterval(setStripe);
      }},
      500)
  }

  checkoutElement(){
    stripe = Stripe(this.data.get('key'));
    const options = {
      mode: 'payment',
      amount: parseFloat(this.amountInputTarget.value * 100),
      currency: 'usd',
      paymentMethodTypes: ['card'],
      paymentMethodCreation: 'manual'
    };
    elements = stripe.elements(options);

    const paymentElement = elements.create('payment'); // or use card
    paymentElement.mount(this.cardElementTarget);

    return paymentElement
  }

  updateElements(){
    if (this.amountInputTarget.value > 0) {
    elements.update({
      amount: parseFloat(this.amountInputTarget.value * 100),
    })
  }
  }

  saveAmount(){
    this.amountDisplayTarget.innerHTML = this.amountInputTarget.value

    if (this.amountInputTarget.value > 0 ){
      this.amountInputTarget.classList.add('d-none')
      this.saveAmountBtnTarget.classList.add('d-none')

      this.amountDisplayTarget.classList.remove('d-none')
      this.editAmountBtnTarget.classList.remove('d-none')
      this.submitBtnTarget.classList.remove('d-none')
      this.checkout()
    }else {
      alert('Amount must be greater than 0')
    }
  }

  editAmount(){

      this.amountInputTarget.classList.remove('d-none')
      this.saveAmountBtnTarget.classList.remove('d-none')

      this.amountDisplayTarget.classList.add('d-none')
      this.editAmountBtnTarget.classList.add('d-none')
      this.submitBtnTarget.classList.add('d-none')
  }






  checkout(){
    const controller = this
    
    // Handle real-time validation errors from the card Element.
    const submitBtn = this.submitBtnTarget;
    const handleError = (error) => {
      const messageContainer = controller.cardErrorsTarget;
      messageContainer.textContent = error.message;
      submitBtn.disabled = false;
    }

    paymentElement.on('change', function (event) {
        var displayError = controller.cardErrorsTarget;
        if (event.error) {
            displayError.textContent = event.error.message;

        } else {
            displayError.textContent = '';
            submitBtn.disabled = false;

        }
    });

    // Handle form submission.
    var form = controller.formTarget;
    form.addEventListener('submit', function (event) {
        event.preventDefault();
          // Prevent multiple form submissions
  if (submitBtn.disabled) {
    return;
  }

  // Disable form submission while loading
  submitBtn.disabled = true;

  const {error: submitError} = elements.submit();
  if (submitError) {
    handleError(submitError);
    return;
  }
        stripe.createPaymentMethod({elements}).then(function (result) {
            if (result.error) {
                // Inform the user if there was an error.
                var errorElement = controller.cardErrorsTarget;
                errorElement.textContent = result.error.message;
            } else {
                // Send the token to your server.
                controller.stripeTokenHandler(result.paymentMethod);
            }
        });
    });


  }
  // Submit the form with the token ID.
  stripeTokenHandler(token) {
    console.log(token)
      // Insert the token ID into the form so it gets submitted to the server
      var form = this.formTarget;
      var hiddenInput = document.createElement('input');
      hiddenInput.setAttribute('type', 'hidden');
      hiddenInput.setAttribute('name', 'stripeToken');
      hiddenInput.setAttribute('value', token.id);
      form.appendChild(hiddenInput);
      // Submit the form
      form.submit();
  }
}
